export default __webpack_public_path__ + "static/media/polaroid5.b478fc2b.jpg";